import { fetchCachedHelper } from '../../../api/api'
import { classDetailsActions } from './classDetailsSlice'

export const getClass = id => async dispatch => {
    dispatch(classDetailsActions.getClassDetailsRequest())
    try {
        const [classRes, relatedClasses] = await Promise.all([
            fetchCachedHelper(`Inclass/${id}`),
            getRelatedClasses(id),
        ])
        dispatch(
            classDetailsActions.getClassDetailsRequestSuccess({
                class: classRes.data,
                relatedClasses,
            })
        )
    } catch (e) {
        dispatch(classDetailsActions.getClassDetailsRequestError(e.message))
    }
}

const getRelatedClasses = async id => {
    const response = await fetchCachedHelper(
        `Inclass/GetRelatedClassesByID/${id}`
    )
    return response.data
}
